var exports = {
  "Kk": "VoiceSettingsMenus.module__icon___SzAzcF",
  "XK": "VoiceSettingsMenus.module__leadingActionLabel___SzAzcF",
  "CS": "VoiceSettingsMenus.module__inputLevelItem___SzAzcF",
  "lL": "VoiceSettingsMenus.module__inputLevelLabel___SzAzcF",
  "_A": "VoiceSettingsMenus.module__inputLevelMeter___SzAzcF",
};

module.exports = exports;
